import {
  GET_MAJORATIONS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  majorations: [],
  error: {},
};

const Majoration = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_MAJORATIONS:
          return {
            ...state,
            majorations: action.payload.data,
            isMajorationCreated: false,
            isMajorationSuccess: true,
          };

        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_MAJORATIONS:
          return {
            ...state,
            error: action.payload.error,
            isMajorationCreated: false,
            isMajorationSuccess: false,
          };

        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Majoration;
